import type { SVGProps } from 'react';
const SvgBell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Bell_svg__a)">
      <path
        d="M8 2.4V.998m0 1.4a4.667 4.667 0 0 1 4.667 4.667c0 4.385.934 5.134.934 5.134H2.4s.933-1.192.933-5.134A4.667 4.667 0 0 1 8 2.4M6.5 13v.774c0 .393.158.77.44 1.05a1.51 1.51 0 0 0 2.12 0c.282-.28.44-.657.44-1.05V13"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Bell_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBell;
